import { MerchItem } from "./lib";
import { merchShopAssets } from "assets/cdn";

export const getMerchItems = (
	getImage: (url: string) => string
): MerchItem[] => [
	{
		desktopImage: getImage(merchShopAssets.items.explore.desktop),
		mobileImage: getImage(merchShopAssets.items.explore.mobile),
		buttonLabel: "Explore",
		link: "https://merch.solitairetripeaks.com/"
	},
	{
		desktopImage: getImage(merchShopAssets.items.apparel.desktop),
		mobileImage: getImage(merchShopAssets.items.apparel.mobile),
		buttonLabel: "Apparel",
		link: "https://merch.solitairetripeaks.com/apparel"
	},
	{
		desktopImage: getImage(merchShopAssets.items.accessories.desktop),
		mobileImage: getImage(merchShopAssets.items.accessories.mobile),
		buttonLabel: "Accessories",
		link: "https://merch.solitairetripeaks.com/accessories"
	}
];
